export interface Author {
  id: string;
  name: string;
  role: string;
  bio: string;
  credentials: string;
  avatar: string;
}

export const AUTHORS: Author[] = [
  {
    id: "jonathan-vance",
    name: "Jonathan Vance, CCIM",
    role: "Senior Commercial Real Estate Underwriter & Capital Markets Strategist",
    bio: "Jonathan Vance is a Certified Commercial Investment Member (CCIM) with over 16 years of experience in institutional real estate syndication, capital markets modeling, and asset underwriting across multifamily and industrial portfolios.",
    credentials: "CCIM, MS in Real Estate Finance (NYU Schack)",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=400"
  },
  {
    id: "rachel-holloway",
    name: "Rachel Holloway, MAI",
    role: "CRE Valuation Director & Predictive Asset Modeling Lead",
    bio: "Rachel Holloway is a Designated Member of the Appraisal Institute (MAI) specializing in commercial real estate valuation, discounted cash flow (DCF) modeling, and algorithmic rent growth forecasting for institutional asset managers.",
    credentials: "MAI, B.S. in Economics & Urban Land Economics",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=400"
  },
  {
    id: "david-sterling",
    name: "David Sterling",
    role: "Commercial Lease Optimization & Real Estate Operations Principal",
    bio: "David Sterling advises national tenants and corporate real estate directors on lease structuring, CAM reconciliation, triple-net (NNN) contract negotiations, and multi-tenant portfolio optimization.",
    credentials: "JD / MBA, Commercial Real Estate Council Member",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=400"
  }
];

export function getAuthorForSlug(slug: string): Author {
  if (!slug) return AUTHORS[0];
  let hash = 0;
  for (let i = 0; i < slug.length; i++) {
    hash = (hash * 31 + slug.charCodeAt(i)) | 0;
  }
  return AUTHORS[Math.abs(hash) % AUTHORS.length];
}
